module.exports = __webpack_public_path__ + "media/8_2.61ea4f3f.wav";